export default "__VITE_ASSET__CXXO11mf__"